const RESPONSE_STATUS_CODES = {
    OK: 200,
    NOT_AUTHORIZED: 401,
    ACCESS_FORBIDDEN: 403,
    NOT_FOUND: 404,
    SERVER_ERROR: 500
};

export { RESPONSE_STATUS_CODES };